import { motion } from 'framer-motion';
import { HiOutlineSquare2Stack, HiMinus, HiEye, HiEyeSlash } from 'react-icons/hi2';
import { HiOutlineSlash } from "react-icons/hi2";
import { HiOutlineStop } from "react-icons/hi2";


const AnnotationToolbar = ({ 
  activeAnnotationTool, 
  onToolSelect, 
  showAnnotations,
  onToggleAnnotations,
  user 
}) => {
  const tools = [
    { 
      id: 'box', 
      icon: HiOutlineStop, 
      label: 'Box Annotation', 
      disabled: !user 
    },
    { 
      id: 'line', 
      icon: HiOutlineSlash, 
      label: 'Line Annotation', 
      disabled: !user 
    }
  ];

  return (
    <div className="flex flex-col bg-gray-800/50 border border-gray-700 rounded-lg p-3 gap-3 h-fit backdrop-blur-sm w-fit">
      {/* Annotation Tools */}
      <div className="flex flex-col gap-2">
        <span className="text-xs text-gray-400 px-1 font-medium uppercase tracking-wide">Toolbar</span>
        {tools.map(tool => {
          const IconComponent = tool.icon;
          return (
            <motion.button
              key={tool.id}
              onClick={() => !tool.disabled && onToolSelect(tool.id)}
              disabled={tool.disabled}
              className={`p-3 rounded-lg transition-all duration-200 flex items-center justify-center ${
                activeAnnotationTool === tool.id
                  ? 'bg-primary text-white shadow-lg shadow-primary/25'
                  : tool.disabled
                  ? 'bg-gray-700/30 text-gray-500 cursor-not-allowed'
                  : 'bg-gray-700/50 text-gray-300 hover:bg-gray-600/50 hover:text-white'
              }`}
              whileHover={!tool.disabled ? { scale: 1.05 } : {}}
              whileTap={!tool.disabled ? { scale: 0.95 } : {}}
              title={tool.disabled ? 'Login to use annotation tools' : tool.label}
            >
              <IconComponent className="w-5 h-5" />
            </motion.button>
          );
        })}
      </div>

      {/* Toggle Annotations */}
      <div className="flex flex-col gap-2 border-t border-gray-700 pt-3">
        <span className="text-xs text-gray-400 px-1 font-medium uppercase tracking-wide">View</span>
        <motion.button
          onClick={onToggleAnnotations}
          className={`p-3 rounded-lg transition-all duration-200 flex items-center justify-center ${
            showAnnotations
              ? 'bg-green-600/20 text-green-400 border border-green-600/30'
              : 'bg-gray-700/50 text-gray-300 hover:bg-gray-600/50 hover:text-white'
          }`}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          title={showAnnotations ? 'Hide annotations' : 'Show annotations'}
        >
          {showAnnotations ? (
            <HiEye className="w-5 h-5" />
          ) : (
            <HiEyeSlash className="w-5 h-5" />
          )}
        </motion.button>
      </div>
    </div>
  );
};

export default AnnotationToolbar;
